import {ShiftList} from "./ShiftList.tsx";


export const ShiftListPage = () => {
    return <>

            <h1>Shifts</h1>
            <ShiftList/>

    </>
}